<!-- 
  上部メニュー
-->
<template>
  <div>
    <div class="row header align-items-center" >
      <div class="col-auto">
        <img src="@/assets/acrypro/logo.svg" style="cursor: pointer" @click="backhome()" />
        <span v-if="!isAcryTicketPage" class="deliv-text fw-bold">{{delivText}}</span><span class="acry-error-text fw-bold ms-3">{{sampleText}}</span>
      </div>
      <div class="col"></div>
      <div class="col-auto p-3 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowEdit && this.$store.state.tutorial.editStep == 2}">
        <button
          class="btn cart-btn fw-bold"
          :class="{ 'cart-open': this.$store.state.isShowCart }"
          style="width: 160px; height: 40px"
          @click="cartAction"
        >
          カート({{ this.$store.state.cartManager.getCartList().length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import { CenterViewState } from "@/js/Const.js";

export default {
  name: "HomeTop_Ap",
  props: {},
  data: function () {
    return {
      allPrice: 0,
      delivText: "只今最短発送日 取得中",
    };
  },
  computed: {
    sampleText(){
      return ([CenterViewState.SampleUpload, CenterViewState.SamplePreview].includes(this.$store.state.centerViewState))?"サンプル注文はこちらよりも発送が早まる場合があります":"";
    },
    isAcryTicketPage(){
      return ([
        CenterViewState.EventManagement, CenterViewState.EventCreate, CenterViewState.EventCreateDesign,
        CenterViewState.EventEdit, CenterViewState.EventTicketIssue, CenterViewState.TicketOrderConfirm,
        CenterViewState.TicketIssueHistory, CenterViewState.TicketIssueDetail, CenterViewState.EventDesignUpload,
        CenterViewState.EventList
       ].includes(this.$store.state.centerViewState));
    }
  },
  created: function () 
  {
    this.getDelivText();
  },
  components: {},
  methods: {
    cartAction() {
      this.$store.commit("switchShowCart");
    },
    async getDelivText() {
      const delivDate = await this.getDelivData();
      let dt = new Date();
      dt.setDate(dt.getDate() + delivDate);
      this.delivText = `只今最短発送日 ${dt.getMonth()+1}月${dt.getDate()}日`;
    },
    async getDelivData() {
      const ref = firebase.firestore().collection("AcrySetting");
      const snapshot = await ref.where("type", "==", "deliverypro").get();
      const data = snapshot.docs[0].data();
      return parseInt(data.value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.deliv-text {
  margin-left: 40px;
  color: $text-main-color;
}

.cart-btn {
  color:  #8897be;
  background: white;
  border-radius: 20px;
  font-size: 16px;
  border: 3px solid $primary-main-color;
}
.cart-open {
  /* // margin: 10px; */
  padding-top: 7px;
  color: #ffffff;
  background: #8897be;
  font-size: 16px;
  border:none;
}
.cart-btn:hover {
  color: #8897be;
  background: #ffffff;
}
.cart-open:hover {
  color: #ffffff;
  background: #8897be;
}
.feature-ui{
  z-index: 5;
  pointer-events: none;
  background: white;
}
</style>
